// REACT IMPORTS
import React from "react";

// COMPONENT IMPORTS
import { Disclosure } from "@headlessui/react";

// ICON IMPORTS
import { ArrorwBottom } from "icons/sidebar/ArrorwBottom";

// PROPS TYPES
interface AccordionProps {
  title: string;
  content: any;
  "data-testid"?: string;
  "aria-label"?: string;
}

/* ------------------------------------- ACCORDION ------------------------------------- */

const Accordion = (props: AccordionProps) => {
  const { title, content, ...accordionProps } = props;
  const buttonLabel = accordionProps["aria-label"] || `${title} details`;
  return (
    <Disclosure defaultOpen>
      {({ open }) => (
        /* Use the `open` state to conditionally change the direction of an icon. */
        <>
          <div
            className="flex items-center gap-2"
            data-testid={accordionProps["data-testid"]}
          >
            <div className="lg:text-base text-sm leading-normal text-txtPrimary font-medium">
              {title}
            </div>
            <Disclosure.Button
              aria-label={buttonLabel}
              data-testid={
                accordionProps["data-testid"]
                  ? `${accordionProps["data-testid"]}-toggle`
                  : undefined
              }
            >
              <ArrorwBottom
                aria-hidden="true"
                width="20"
                height="20"
                className={`${open ? "rotate-[360deg]" : "rotate-180"}`}
              />
            </Disclosure.Button>
          </div>
          <Disclosure.Panel>{content}</Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default Accordion;
